import MainContent from "../component/content/MainContent";

const Home = () => {
    return (
        <MainContent />
    )
};

export default Home;